// extracted by mini-css-extract-plugin
export default {"burger_menu":"BurgerMenu_burger_menu__oP6sB","opened":"BurgerMenu_opened__bk97Z","close_btn":"BurgerMenu_close_btn__OIrTh"};